import { render, staticRenderFns } from "./AcademiaOnline.vue?vue&type=template&id=0ad19136&scoped=true"
import script from "./AcademiaOnline.vue?vue&type=script&lang=js"
export * from "./AcademiaOnline.vue?vue&type=script&lang=js"
import style0 from "./AcademiaOnline.vue?vue&type=style&index=0&id=0ad19136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad19136",
  null
  
)

export default component.exports